<template>
    <company_info :user_id="contragent.id"></company_info>
</template>

<script>
import company_info from "../../../../vkursi/company_info.vue";

export default {
    name: "cont_vkursi",
    
    components: {
        company_info
    },
    props : {
        contragent : {
            type : Object,
            required : true,
        }
    }
}
</script>



<style scoped>

</style>